import {Box, Button, Chip, useTheme} from "@mui/material";
import Typography from "@mui/material/Typography";
import {observer} from "mobx-react";
import * as React from "react";
import PermissionListGroup from "./PermissionListGroup";
import PermissionMatrixGroup from "./PermissionMatrixGroup";

function PermissionGroupSection({permissionGroup, form, fieldName, matchesPermissionSearch}) {
    const theme = useTheme();
    const style = styles(theme);
    const groupBodies = {list: PermissionListGroup, matrix: PermissionMatrixGroup}
    const GroupBody = groupBodies[permissionGroup.type]

    const assignedPermissions = form.getFieldValue(fieldName)
    const groupPermissions = permissionGroup.permissions
    const assignedGroupPermissionsCount = groupPermissions.filter(permission => assignedPermissions.includes(permission)).length
    const isWholeGroupAssigned = assignedGroupPermissionsCount === groupPermissions.length

    const assignOrRevokeWholeGroup = async () => {
        const permissionsOutsideGroup = assignedPermissions.filter(permission => !groupPermissions.includes(permission))
        const editedPermissions = isWholeGroupAssigned ? permissionsOutsideGroup : [...permissionsOutsideGroup, ...groupPermissions]
        await form.updateFieldWithValue(fieldName, editedPermissions)
    }

    return (
        <Box component="section" sx={style.groupContainer}>
            <Box sx={style.groupHeader}>
                <Typography variant="h3" sx={style.groupTitle}>{permissionGroup.name}</Typography>
                <Box display="flex" alignItems="center" gap={1}>
                    <Chip size="small" label={`${assignedGroupPermissionsCount}/${groupPermissions.length}`}/>
                    <Button size="small" onClick={assignOrRevokeWholeGroup}>
                        {isWholeGroupAssigned ? 'Ninguno' : 'Todos'}
                    </Button>
                </Box>
            </Box>
            <GroupBody
                permissionGroup={permissionGroup}
                form={form}
                fieldName={fieldName}
                matchesPermissionSearch={matchesPermissionSearch}
            />
        </Box>
    )
}

export default observer(PermissionGroupSection);

const styles = (theme) => ({
    groupContainer: {
        padding: '1rem 1.25rem',
        backgroundColor: theme.brand.field,
        border: `0.5px solid ${theme.palette.divider}`,
        borderRadius: '16px',
    },
    groupHeader: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: '0.5rem',
        paddingBottom: '0.5rem',
        borderBottom: `1px solid ${theme.palette.divider}`,
    },
    groupTitle: {
        fontSize: '1rem',
    },
})
